<!-- Alert for multi-tab detection -->
<div *ngIf="isOpenInAnotherTab" class="alert alert-info mx-3 mb-3">
  <i class="fa fa-window-restore"></i>
  <strong>You are already editing this form in another browser tab.</strong>
  This instance is in read-only mode to prevent conflicts.
  <span *ngIf="otherTabOpenTime">
    (Opened since {{otherTabOpenTime | date:'medium'}})
  </span>
  <button class="btn btn-primary" (click)="takeOverOwnForm()">Unlock the form</button>

</div>

<!-- Alert for form locked by other user -->
<div *ngIf="isLockedByOtherUser && !isOpenInAnotherTab && !readingMode" class="alert alert-warning mx-3 mb-3">
  <i class="fa fa-lock"></i>
  <strong>This form is currently being edited by {{lockedByUser}}.</strong>
  You can only view it in read-only mode until they finish editing.
  <span *ngIf="lockedByDate">
    (Locked since {{lockedByDate | date:'medium'}})
  </span>
  <button class="btn btn-primary" (click)="takeOverForm()">Unlock the form</button>
</div>

<!-- Alert for when another tab/user has taken over while this tab was editing -->
<div *ngIf="formTakenOver" class="alert alert-danger mx-3 mb-3">
  <i class="fa fa-exclamation-triangle"></i>
  <strong>This form has been taken over by {{formTakenOverBy}}.</strong>
  Changes in this window can no longer be saved. Reload to see their version, then take
  the form over if you still need to edit it.
  <button class="btn btn-primary ms-2" (click)="reloadAfterTakeover()">Reload the form</button>
</div>

<!-- Regular read-only info alert (only show if not locked by someone else and not open in another tab) -->
<div *ngIf="readingMode" class="alert alert-info mx-3 mb-3">
  <i class="fa fa-info-circle"></i>
  You are viewing this form in read-only mode. No changes can be made.
</div>

<div class="container-fluid">

  <!-- Combined header row with breadcrumb and PDF button -->
  <div class="header-row mx-3 mb-3 d-flex justify-content-between align-items-center">
    <!-- Breadcrumb navigation (left side) -->
    <div class="breadcrumb-container">
      <app-breadcrumb></app-breadcrumb>
    </div>
    <!-- PDF download dropdown and queue actions (right side) -->
    <div class="d-flex gap-2 align-items-center">
      <!-- Autosave problems only, never a confirmation, so nobody skips Save -->
      <div *ngIf="autosaveState.status === 'error' || autosaveState.status === 'expired'"
        class="autosave-indicator autosave-indicator--problem">
        <i class="fa fa-exclamation-triangle"></i>
        {{ autosaveState.message }}<span *ngIf="autosaveState.status === 'error'">, retrying</span>
      </div>

      <div *ngIf="submissionId && availableForms.length > 0" class="dropdown">
        <button class="btn pdf-download-btn dropdown-toggle" type="button" id="dropdownMenuButton"
          data-bs-toggle="dropdown" aria-expanded="false">
          <i class="fa fa-file-pdf-o"></i> Download Forms
        </button>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
          <li *ngIf="availableForms.length > 0">
            <hr class="dropdown-divider" />
          </li>
          <li *ngFor="let form of availableForms; let i = index">
            <a class="dropdown-item" (click)="downloadSinglePdf(i)">
              Download {{ form.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Message display -->
  <div *ngIf="downloadMessage" class="alert alert-success mx-3 alert-dismissible fade show">
    <i class="fa fa-check-circle"></i> {{ downloadMessage }}
    <button type="button" class="btn-close" (click)="dismissMessage()" aria-label="Close"></button>
  </div>

  <!-- Error display -->
  <div *ngIf="downloadError" class="alert alert-danger mx-3 alert-dismissible fade show">
    <i class="fa fa-exclamation-circle"></i> 
    <span [innerText]="downloadError"></span>
    <button type="button" class="btn-close" (click)="dismissError()" aria-label="Close"></button>
  </div>

  <ul class="nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
      <button class="nav-link active" id="formio-tab" data-bs-toggle="tab" data-bs-target="#formio-pane" type="button"
        role="tab">
        Intake
      </button>
    </li>
    <li class="nav-item" role="presentation" *ngIf="getABNTab">
      <button class="nav-link" id="abn-tab" data-bs-toggle="tab" data-bs-target="#abn-pane" type="button"
        (click)="renderABNForm(true)" role="tab">
        ABN
      </button>
    </li>
    <li class="nav-item" role="presentation" *ngIf="showPITab">
      <button class="nav-link" id="pi-tab" data-bs-toggle="tab" data-bs-target="#pi-pane" type="button"
        (click)="renderPIForm()" role="tab">
        Personal Injury Agreement
      </button>
    </li>
    <li class="nav-item" role="presentation" *ngIf="showConsentFormsTab">
      <button class="nav-link" id="consent-forms-tab" data-bs-toggle="tab" data-bs-target="#consent-forms-pane" type="button"
        (click)="renderMergedConsentForms()" role="tab">
        Consent Forms
      </button>
    </li>
  </ul>

  <div class="tab-content mt-3">
    <div class="tab-pane fade show active" id="formio-pane" role="tabpanel">
      <div class="center-div">
        <div id="formio"></div>
      </div>
      <ul *ngIf="!firstLoad" id="wizard-etsm5x-nav" style="border-top: none; padding-top:0;"
        class="formio-wizard-nav-container list-inline">
        <li *ngIf="!isReadOnly">
          <button aria-label="Cancel button. Click to reset the form" ref="wizard-etsm5x-cancel"
            class="btn btn-secondary btn-wizard-nav-cancel" (click)="triggerCancel($event, isReadOnly)">Cancel</button>
        </li>

        <li *ngIf="!this.formData?.data?.consentOfPrivacyInformedAA">
          <button aria-label="Submit Form button. Click to submit the form" ref="wizard-er2wyvf-submit"
            class="btn btn-primary btn-wizard-nav-submit" (click)="saveIntakeAndStay()">Save Changes</button>
        </li>


        <li *ngIf="this.formData?.data?.consentOfPrivacyInformedAA">
          <button aria-label="Next button. Click to go to the next tab" ref="wizard-eoodlvc-next"
            (click)="saveIntake(true)" class="btn btn-primary btn-wizard-nav-next">Save and Continue</button>
        </li>

      </ul>
    </div>

    <div class="tab-pane fade pdf-container" #pdfContainer id="abn-pane" role="tabpanel" *ngIf="getABNTab">
      <pdf-viewer #pdfViewer [src]="pdfABNSrc!" [show-all]="true" style="display: block; height: 600px;">
      </pdf-viewer>
      <div class="signature-controls">
        <button class="btn-secondary sign-btn" (click)="openSignatureModal()" class="sign-btn" [disabled]="isReadOnly || !!formData?.data?.abnNestedForm?.data?.signatureAbn">
          Click to Sign
        </button>
        <input type="date" class="pdf-overlay-input date-input" (change)="setSignatureDate($event)"
          [value]="signatureDate" [disabled]="isReadOnly || isABNFormFullyLocked()" style="top: 250px; left: 200px; width: 160px;" />
      </div>
      <div class="modal" *ngIf="showSignatureModal">
        <div class="modal-content">
          <button class="close-btn" (click)="closeSignatureModal()" aria-label="Close">
            <span title="Close" aria-hidden="true">&times;</span>
          </button>
          <canvas #signatureCanvas width="200" height="100"></canvas>
          <div class="signature-pad-footer">
            Sign above
          </div>
          <div class="modal-actions">
            <button class="clear-btn" (click)="clearSignature()">
              <i title="Clear" class="bi bi-arrow-clockwise"></i>
            </button>
            <button class="done-btn btn-primary" (click)="saveSignature()">
              Done
            </button>
          </div>
        </div>
      </div>

      <ul id="wizard-etsm5x-nav" class="formio-wizard-nav-container list-inline">
        <li *ngIf="!isReadOnly">
          <button aria-label="Cancel button. Click to reset the form" ref="wizard-etsm5x-cancel"
            class="btn btn-secondary btn-wizard-nav-cancel" (click)="triggerCancel($event, isReadOnly)">Cancel</button>
        </li>

        <li>
          <button aria-label="Previous button. Click to go back to the previous tab" ref="wizard-etsm5x-previous"
            class="btn btn-primary btn-wizard-nav-previous" (click)="goToIntakeForm()">Previous</button>
        </li>

        <li>
          <button aria-label="Next button. Click to go to the next tab" ref="wizard-eoodlvc-next"
            (click)="saveABNForm(true)" class="btn btn-primary btn-wizard-nav-next">Save and Continue</button>
        </li>

      </ul>
    </div>

    <div class="tab-pane fade pdf-container" id="pi-pane" role="tabpanel" *ngIf="showPITab">
      <pdf-viewer [src]="pdfPISrc!" [show-all]="true" style="display: block; height: 600px;">
      </pdf-viewer>

      <ul id="wizard-pi-nav" class="formio-wizard-nav-container list-inline">
        <li *ngIf="!isReadOnly">
          <button aria-label="Cancel button. Click to reset the form"
            class="btn btn-secondary btn-wizard-nav-cancel" (click)="triggerCancel($event, isReadOnly)">Cancel</button>
        </li>
        <li>
          <button aria-label="Previous button. Click to go back to the previous tab"
            class="btn btn-primary btn-wizard-nav-previous" (click)="goBackFromPI()">Previous</button>
        </li>
        <li>
          <button aria-label="Next button. Click to go to the next tab"
            (click)="savePIForm(true)" class="btn btn-primary btn-wizard-nav-next">Save and Continue</button>
        </li>
      </ul>
    </div>

    <div class="tab-pane fade" id="consent-forms-pane" role="tabpanel" *ngIf="showConsentFormsTab">
      <pdf-viewer [src]="mergedConsentPdfSrc!" [show-all]="true" style="display: block; height: 600px;">
      </pdf-viewer>

      <ul id="wizard-consent-forms-nav" class="formio-wizard-nav-container list-inline">
        <li *ngIf="!isReadOnly">
          <button aria-label="Cancel button. Click to reset the form" ref="wizard-consent-forms-cancel"
            class="btn btn-secondary btn-wizard-nav-cancel" (click)="triggerCancel($event, isReadOnly)">Cancel</button>
        </li>
        <li>
          <button aria-label="Previous button. Click to go back to the previous tab" ref="wizard-consent-forms-previous"
            class="btn btn-primary btn-wizard-nav-previous" type="button" (click)="goBackFromConsentForms()">
            Previous
          </button>
        </li>

        <li *ngIf="!isReadOnly">
          <button aria-label="Submit Form button. Click to submit the form" ref="wizard-consent-forms-submit"
            class="btn btn-primary btn-wizard-nav-submit" (click)="saveIntakeAndStay()">Save Changes</button>
        </li>

        <!-- <li>
          <span class="info-tooltip" tabindex="0">
            <i class="fa fa-info-circle"></i>
            <span class="info-tooltip-text">
              Once the form is saved, it will attempt to create or update an existing verification request to Curve using the data from the intake form.
            </span>
          </span>
        </li> -->

      </ul>
    </div>

  </div>
</div>
